import React, { useState } from 'react'

// Deps
// import { connect } from 'react-redux'

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Services
import orderServices from 'services/order'

const useCloseOptions = (orderData) => {
	let opts = [
		{ value: 1, label: 'Ödemeyi ödenen tutara düşür.' /*, isDisabled: true*/},
		{ value: 2, label: 'Kalan tutarı nakit aldım.'},
		{ value: 3, label: 'Kalan tutarı havale aldım.'}
	];

	if(orderData && orderData.payment_amount) {
		opts[0].label += ' (' + orderData.payment_amount + ' '+orderData.price_type.currency_symbol+')';
	}

	return opts;
}

const CancelOrderModal = (props) => {
	const orderData = props.orderData;
	const close = props.close;

	const closeOptions = useCloseOptions(orderData);

	const [submitting, setSubmitting] = useState(false);
	const [selectedCloseOption, setSelectedCloseOption] = useState(false);

	const submit = (formData) => {
		setSubmitting(true);

		formData = {...formData, order_business_code: orderData.business_order_code};

		orderServices.cancelOrder(formData).then(() => {
			props.onSuccess();

			close();
		}).catch(() => {}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">Ödemeyi Kapat</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content grid-container">
				<div className="row">
					<div className="col">
						<FormInput
							disabled={submitting}
							type="select"
							z="4"
							label="Ödemeyi Nasıl Kapatmak İstiyorsunuz?"
							placeholder="Ödemeyi kapatmak için bir yöntem seçin."
							options={closeOptions}
							value={selectedCloseOption}
							onChange={(val) => { setSelectedCloseOption(val); }}
							name="cancel_type" />
					</div>
				</div>
				{(selectedCloseOption && (selectedCloseOption.value === 2 || selectedCloseOption.value === 3)) &&
					<div className="row">
						<div className="col">
							<FormInput
								disabled={submitting}
								type="text"
								label={selectedCloseOption.value === 2 ? 'Kişi Adı' : 'Banka Adı'}
								placeholder={selectedCloseOption.value === 2 ? 'Kalan tutarı teslim eden kişi adı.' : 'Kalan tutarın yatırıldığı banka adı.'}
								validation={{
									required: (selectedCloseOption.value === 2 ? 'Bir kişi adı girmelisiniz.' : 'Bir banka adı girmelisiniz.')
								}}
								name="collector_name" />
						</div>
					</div>
				}
				{(selectedCloseOption && selectedCloseOption.value === 3) &&
					<div className="row">
						<div className="col">
							<FormInput
								disabled={submitting}
								type="text"
								label="IBAN"
								mask="iban"
								placeholder="Havale gerçekleştiren IBAN numarası"
								validation={{
									required: 'Bir IBAN numarası girmelisiniz.',
									iban: true,
								}}
								name="collector_iban" />
						</div>
					</div>
				}
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting}
					type="submit">
					Ödemeyi Kapat
				</Btn>
			</div>
		</InputForm>
	)
}

CancelOrderModal.defaultProps = {
	className: '',
	containerClass: 'modal-cancel-order mobile-full',
	name: 'cancel-order',
	title: false,
	content: false,
	source: false,
	groupID: false,
	accountID: false,
}

export default CancelOrderModal